module.exports = __webpack_public_path__ + "static/contact-card-d61c40358656328dcfbd09ff6d5daef5.jpg";